<template>
  <div class="message-block message-button">
    <template v-for="(button, index) in buttons">
      <a :href="`tel:${button.phone_number}`" target="_blank" :key="index" v-if="button.type === 'call_button'">
        <div class="button-action" :title="button.phone_number">
          <v-icon name="phone-square" scale="0.9" fill="#1890ff" />
          {{button.title || button.phone_number | truncate(20)}}
        </div>
      </a>
      <a :href="button.url" target="_blank" :key="index" v-if="button.type === 'url_button'">
      <div class="button-action" :key="index" :title="button.title">
        <v-icon name="link" scale="0.9" fill="#1890ff" />
        {{button.title || button.url | truncate(20)}}
      </div>
      </a>
			<div class="button-action" :key="index" v-if="button.type === 'widget_ask_desktop_notify_button'" @click="openNotify()" :title="button.title">
        {{button.title | truncate(20)}}
      </div>
      <div class="button-action" :key="index" v-if="button.type === 'widget_ask_contact_info_button'" @click.stop="openSetting()" :title="button.title">
        {{button.title | truncate(20)}}
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import store from '../store'
import eventHub from '../lib/hub'

export default {
  name: 'message-button',
  props: ['buttons'],
  computed: {
    ...mapState([
      'themeColor'
    ])
  },
  methods: {

    openSetting () {
      eventHub.$emit('widget.openSetting', 'user-info-form')
    },

    async openNotify () {
      await store.dispatch('subscribePushNotification')
    }
  }
}
</script>
